module.exports = __webpack_public_path__ + "img/datamatrix_72ppi.df553c21.png";